import ReactGA from 'react-ga4';

export const setGAEvent = (event) => {
  ReactGA.gtag('event', event.name, {
    event_category: event.category,
    event_label: event.label,
  });
};
